const dataNumbers = [
    {
        num: 276,
        title: 'SCRUB OPTIONS'
    },
    {
        num: 530,
        title: 'MONTHLY VISITS'
    },
    {
        num: 308,
        title: 'TREATMENTS'
    },
    {
        num: 264,
        title: 'FACIAL PRODUCTS'
    }
]
export default dataNumbers;
